import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class FeatureTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "ledColumn", title: "Status" },
        { name: "blueColumn", title: "Blaue LED" },
        { name: "redColumn", title: "Rote LED" },
      ],
      rows: [
        { ledColumn: 'Durchgehend an ', blueColumn: 'Mit WLAN verbunden', redColumn: 'N/A' },
        { ledColumn: 'Blinkt langsam', blueColumn: 'WPS Modus aktiv', redColumn: 'Kamera ist eingeschaltet' },
        { ledColumn: 'Blinkt schnell', blueColumn: 'Keine Verbindung zu WLAN', redColumn: 'Firmware-Upgrade im Gange' },
        { ledColumn: 'Aus', blueColumn: 'LED ist deaktiviert oder Kamera hat keinen Strom', redColumn: 'LED ist deaktiviert oder Kamera hat keinen Strom' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

FeatureTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(FeatureTable)